module.exports = __webpack_public_path__ + "static/media/P28.8c4aab3c.png";